import { StoreProvider } from './contexts/store-provider';
import { UnsavedChangesProvider } from './contexts/unsaved-changes';
import { Switch, Route } from 'react-router-dom';

import {
    Security as SecurityComponent,
    SecureRoute,
    LoginCallback,
} from '@okta/okta-react';

import { LoginPage, HomePage } from './containers';
import { oktaAuth, restoreOriginalUri } from './utils/okta';

function App() {
    return (
        <SecurityComponent
            oktaAuth={oktaAuth}
            restoreOriginalUri={restoreOriginalUri}
        >
            <StoreProvider>
                <UnsavedChangesProvider>
                    <Switch>
                        <Route
                            path="/login/callback"
                            component={LoginCallback}
                        />
                        <Route path="/login">
                            <LoginPage />
                        </Route>
                        <SecureRoute path="/">
                            <HomePage />
                        </SecureRoute>
                    </Switch>
                </UnsavedChangesProvider>
            </StoreProvider>
        </SecurityComponent>
    );
}

export default App;
